// src/components/circle/circle.component.js
import React, { Component } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import styled, { createGlobalStyle } from "styled-components";
import ReactGA from "react-ga4";
//import QRCode from "react-qr-code";
import { QRCodeCanvas } from "qrcode.react";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.bealyo.bealyoapp";

const APP_STORE_URL = "https://apps.apple.com/app/id6773874077";

//const APP_STORE_URL = "PASTE_YOUR_APP_STORE_URL_HERE";

const CircleLogoContainer = styled.div`
  width: 150px;
  height: 82px;
  margin: 0 auto 14px;
  padding: 6px 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  overflow: hidden;
`;

const CircleLogo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;

const GlobalStyle = createGlobalStyle`
  html, body, #root {
    margin: 0;
    padding: 0;
    min-height: 100%;
    width: 100%;
  }

  body {
    overflow-x: hidden;
    overflow-y: auto;
    background: linear-gradient(135deg, #232d3d 0%, #2c374a 50%, #1b2230 100%);
    font-family: Arial, sans-serif;
  }

  .p-circle {
    word-break: break-word;
    overflow-wrap: break-word;
  }
`;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #232d3d 0%, #2c374a 50%, #1b2230 100%);
  overflow-x: hidden;
  overflow-y: auto;
  text-align: ${({ dir }) => (dir === "rtl" ? "right" : "left")};
`;

const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 800px;
  padding: 20px 0 40px 0;
  box-sizing: border-box;
`;

const Logo = styled.img`
  width: 72px;
  height: auto;
  margin: 0;
`;

const CircleCard = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  padding: 20px;
  margin: 20px;
  width: calc(100% - 40px);
  max-width: 600px;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
`;

const CircleTitle = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center;
`;

const CircleDescription = styled.p`
  font-size: 15px;
  line-height: 1.65;
  margin: 12px 0 6px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;

  ${({ $expanded }) =>
    !$expanded &&
    `
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 10;
      overflow: hidden;
    `}
`;

const MoreButton = styled.button`
  border: 0;
  background: transparent;
  color: #7dc0ff;
  padding: 4px 0;
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
`;

const JoinSteps = styled.ol`
  list-style: none;
  padding: 0;
  margin: 24px 0 18px;
  display: grid;
  gap: 12px;
`;

const JoinStep = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.05);
  text-align: start;

  > div {
    flex: 1;
    min-width: 0;
  }

  strong {
    display: block;
    font-size: 15px;
    margin-bottom: 4px;
  }

  p {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: #cbd5e1;
  }
`;

const StepNumber = styled.span`
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #007df4;
  color: white;
  font-weight: 800;
`;

const OpenCircleButton = styled.a`
  display: block;
  margin-top: 18px;
  padding: 14px;
  border-radius: 12px;
  background: #007df4;
  color: white;
  text-align: center;
  text-decoration: none;
  font-weight: 700;
`;

const StoreButtons = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 8px;
`;

const StoreBadge = styled.img`
  height: 46px;
  width: auto;
  display: block;
  cursor: pointer;
`;

class Circle extends Component {
  constructor(props) {
    super(props);

    const circleId = this.props.match.params.id;

    this.state = {
      circle: {
        id: circleId || "default",
        title: "Fitness Circle",
        description:
          "Join our fitness circle to connect with like-minded people and achieve your goals together.",
        imageUrl: "https://www.bealyo.com/images/prebealyoshare.png",
        createdDate: "2025-01-01",
        participants: 1245,
      },
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    const circleId = this.props.match.params.id;

    console.log("Circle ID:", circleId);

    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });

    axios
      .post(process.env.REACT_APP_API_URL + "circles/pub/byid/", {
        circleId: circleId,
      })
      .then((response) => {
        const apiData = response.data;
        const circleData = apiData.circle;

        console.log("Circle Data:", circleData);

        const randomPlaceholder = Math.floor(Math.random() * 3) + 1;

        this.setState({
          circle: {
            id: circleData._id,
            leaderboardUrl: `/circle/${circleData._id}/leaderboard`,
            title: circleData.name,
            logo: circleData.circle_logo
              ? circleData.circle_logo.startsWith("http")
                ? circleData.circle_logo
                : process.env.REACT_APP_IMG_FOLDER + circleData.circle_logo
              : "",
            description: circleData.description || "",
            descriptions: circleData.descriptions || {},
            hebrewMode: circleData.leaderboardSettings?.rtlMode === true,
            imageUrl:
              circleData.circle_image && circleData.circle_image !== ""
                ? process.env.REACT_APP_IMG_FOLDER + circleData.circle_image
                : process.env.REACT_APP_IMG_FOLDER +
                  `files/circles/placeholder${randomPlaceholder}.png`,
            createdDate: new Date(circleData.created_at).toLocaleDateString(),
            participants: circleData.members ? circleData.members.length : 0,
            type: circleData.circle_type,
          },
          loading: false,
          descriptionExpanded: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching circle:", error);
        this.setState({
          error: "Failed to load circle details",
          loading: false,
          descriptionExpanded: false,
        });
      });
  }

  handleJoinClick = (chid) => {
    ReactGA.event({
      category: "Circle",
      action: "Join Circle Click",
      label: this.state.circle.title,
    });

    const deepLink = `bealyo-app://circle/${chid}`;

    window.location.href = deepLink;

    setTimeout(() => {
      window.location.href = PLAY_STORE_URL;
    }, 1500);
  };

  render() {
    const { circle } = this.state;
    const hebrewMode = circle.hebrewMode === true;

    const englishDescription = circle.descriptions?.en?.trim() || "";

    const hebrewDescription =
      circle.descriptions?.he?.trim() || circle.descriptions?.heb?.trim() || "";

    const description = hebrewMode
      ? hebrewDescription || englishDescription || circle.description || ""
      : englishDescription || circle.description || "";

    const descriptionRTL = /[\u0590-\u05FF]/.test(description);

    const copy = hebrewMode
      ? {
          invite: "בואו להיות חלק ממשהו גדול - יחד",
          subtitle:
            "מצטרפים לקהילה, מתקדמים בקצב שלכם וחוגגים כל הצלחה יחד. המקום שלכם כבר כאן!",
          install: "מתקינים, נרשמים ומתחילים - בחינם",
          installBody:
            "מורידים את Bealyo, פותחים את האפליקציה ונרשמים בחינם. עוד רגע אתם חלק מהחוויה!",
          scan: "סריקה קטנה, חיבור גדול",
          scanBody:
            "פותחים את Bealyo וסורקים את הקוד שמופיע כאן כדי להגיע לקהילה שלנו.",

          join: "מצטרפים ועושים את זה יחד",
          joinBody:
            "לוחצים על הצטרפות באפליקציה - ומתחילים להתקדם, לפרגן ולצבור חוויות יחד.",
          open: "כבר התקנתם? פתחו את הקהילה באפליקציה",
          more: "קראו עוד",
          less: "הצג פחות",
          members: "חברים",
          qr: "קוד ההצטרפות לקהילה",
          rights: "כל הזכויות שמורות.",
        }
      : {
          invite: "Your next chapter starts together",
          subtitle:
            "Move forward, cheer each other on, and make every step count.",
          install: "Install, sign up, and get started - free",
          installBody:
            "Download Bealyo, open the app, and create your free account. You’re one step closer to joining in!",

          scan: "One quick scan brings you closer",
          scanBody: "Open Bealyo and scan the code below to find our Circle.",

          join: "Join in. Move forward together.",
          joinBody:
            "Tap Join in the app and start making progress, cheering each other on, and sharing the experience.",
          open: "Already installed? Open the Circle in Bealyo",
          more: "Read more",
          less: "Show less",
          members: "members",
          qr: "Circle invitation QR",
          rights: "All rights reserved.",
        };
    const isPrivate = circle.type === "private";
    const shareUrl = `https://www.bealyo.com/circle/${circle.id}`;

    const ogTitle = circle.title || "Join a Bealyo Circle";
    const ogDescription =
      circle.description ||
      "Be part of a community-driven challenge on Bealyo.";

    return (
      <PageContainer
        dir={hebrewMode ? "rtl" : "ltr"}
        lang={hebrewMode ? "he" : "en"}
      >
        <Helmet>
          <title>{circle.title} | Bealyo</title>
          <meta name="description" content={ogDescription} />

          <meta property="al:android:package" content="com.bealyo.bealyoapp" />
          <meta
            property="al:android:url"
            content={`bealyo-app://circle/${circle.id}`}
          />
          <meta property="al:android:app_name" content="Bealyo" />

          <meta
            property="al:ios:url"
            content={`bealyo-app://circle/${circle.id}`}
          />
          <meta property="al:ios:app_store_id" content="6773874077" />
          <meta property="al:ios:app_name" content="Bealyo" />

          <meta property="og:type" content="website" />
          <meta property="og:url" content={shareUrl} />
          <meta property="og:title" content={ogTitle} />
          <meta property="og:description" content={ogDescription} />
          <meta property="og:image" content={circle.imageUrl} />

          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content={shareUrl} />
          <meta property="twitter:title" content={ogTitle} />
          <meta property="twitter:description" content={ogDescription} />
          <meta property="twitter:image" content={circle.imageUrl} />
        </Helmet>

        <GlobalStyle />

        <CenteredContainer>
          {this.state.loading ? (
            <CircleCard>Loading… / טוען…</CircleCard>
          ) : this.state.error ? (
            <CircleCard role="alert">
              Could not load the Circle. Please refresh.
              <br />
              לא ניתן לטעון את הקהילה. נסו לרענן.
            </CircleCard>
          ) : (
            <CircleCard>
              {circle.logo ? (
                <CircleLogoContainer>
                  <CircleLogo src={circle.logo} alt={`${circle.title} logo`} />
                </CircleLogoContainer>
              ) : null}

              <CircleTitle>{circle.title}</CircleTitle>

              <div style={{ textAlign: "center", marginBottom: 18 }}>
                <strong style={{ fontSize: 18 }}>{copy.invite}</strong>

                <p style={{ fontSize: 14, lineHeight: 1.6, color: "#cbd5e1" }}>
                  {copy.subtitle}
                </p>
              </div>

              <img
                src={circle.imageUrl}
                alt={circle.title}
                style={{
                  width: "100%",
                  height: 190,
                  objectFit: "cover",
                  borderRadius: 14,
                  display: "block",
                }}
              />

              {description.trim() && (
                <>
                  <CircleDescription
                    id="circle-description"
                    dir={descriptionRTL ? "rtl" : "ltr"}
                    $expanded={this.state.descriptionExpanded}
                    style={{
                      direction: descriptionRTL ? "rtl" : "ltr",
                      textAlign: descriptionRTL ? "right" : "left",
                    }}
                  >
                    {description}
                  </CircleDescription>

                  <MoreButton
                    type="button"
                    aria-controls="circle-description"
                    aria-expanded={this.state.descriptionExpanded}
                    onClick={() =>
                      this.setState((state) => ({
                        descriptionExpanded: !state.descriptionExpanded,
                      }))
                    }
                  >
                    {this.state.descriptionExpanded ? copy.less : copy.more}
                  </MoreButton>
                </>
              )}

              {circle.participants >= 12 && (
                <div
                  style={{
                    marginTop: 12,
                    fontSize: 13,
                    color: "#cbd5e1",
                  }}
                >
                  👥 {circle.participants} {copy.members}
                </div>
              )}

              <JoinSteps>
                <JoinStep>
                  <StepNumber>1</StepNumber>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <strong>{copy.install}</strong>
                    <p>{copy.installBody}</p>

                    <StoreButtons>
                      <a href={APP_STORE_URL} target="_blank" rel="noreferrer">
                        <StoreBadge
                          src="/store-badges/app-store-badge.svg"
                          alt="Download on the App Store"
                        />
                      </a>

                      <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer">
                        <StoreBadge
                          src="/store-badges/google-play-badge.png"
                          alt="Get it on Google Play"
                        />
                      </a>
                    </StoreButtons>
                  </div>
                </JoinStep>

                <JoinStep>
                  <StepNumber>2</StepNumber>
                  <div>
                    <strong>{copy.scan}</strong>
                    <p>{copy.scanBody}</p>
                  </div>
                </JoinStep>

                <JoinStep>
                  <StepNumber>3</StepNumber>
                  <div>
                    <strong>{copy.join}</strong>
                    <p>{copy.joinBody}</p>
                  </div>
                </JoinStep>
              </JoinSteps>

              <div style={{ textAlign: "center" }}>
                <div
                  role="img"
                  aria-label={copy.qr}
                  style={{
                    display: "inline-block",
                    background: "#fff",
                    padding: 12,
                    borderRadius: 14,
                  }}
                >
                  <QRCodeCanvas
                    value={shareUrl}
                    size={150}
                    bgColor="#ffffff"
                    fgColor="#000000"
                    level="L"
                    marginSize={1}
                    style={{
                      display: "block",
                      maxWidth: "100%",
                      height: "auto",
                    }}
                  />
                </div>

                <p style={{ fontSize: 12, color: "#cbd5e1" }}>{copy.qr}</p>
              </div>
              {/**     
              <OpenCircleButton href={`bealyo-app://circle/${circle.id}`}>
                {copy.open}
              </OpenCircleButton>
              */}
            </CircleCard>
          )}

          <div
            style={{
              textAlign: "center",
              color: "rgba(255,255,255,0.55)",
              fontSize: 12,
              padding: "0px 16px 20px",
            }}
          >
            © Bealyo {new Date().getFullYear()}. {copy.rights}
          </div>
        </CenteredContainer>
      </PageContainer>
    );
  }
}

export default Circle;
